<div
  class="status-codes-attachment-container"
  [formGroup]="createAttchementForm">
  <mat-form-field appearance="outline" class="mat-md">
    <mat-label>Attachment</mat-label>
    <input
      placeholder="Select File (.csv,.xls,.pdf)"
      readonly
      matInput
      (click)="!isUploading && attachmentFileInput.click()"
      formControlName="attachmentId" />
    <input
      hidden
      #attachmentFileInput
      type="file"
      accept=".csv,.xls,.pdf"
      (change)="onAttachmentFileSelected($event)" />
    <app-svg-icon
      *ngIf="checkControlHasError('attachmentId')"
      matSuffix
      [iconName]="actionIconsList.infoCircle"
      [isStaticSvg]="true"
      [isFrom]="svgIconFromList.page"
      class="cursor"
      (click)="fetchWidth($event, 'attachmentId')"
      (keydown)="$event.stopPropagation()"></app-svg-icon>
    <app-custom-error-tooltip
      *ngIf="
        checkControlHasError('attachmentId') &&
        setInfoErrorTooltip['attachmentId']
      "
      [tooltipWidth]="setTooltipInfoWidth['attachmentId']"
      [tooltipText]="getAttachmentErrorMessage('attachmentId')"
      (tooltipCloseClicked)="
        commonService.closeErrorTooltip('attachmentId', setInfoErrorTooltip)
      ">
    </app-custom-error-tooltip>
  </mat-form-field>

  <div class="attachment-upload-progress" *ngIf="isUploading">
    <mat-progress-bar
      [mode]="upload.progress ? 'determinate' : 'indeterminate'"
      [value]="upload.progress"></mat-progress-bar>
    <span class="ibc-body-text-small">
      Uploading{{ upload.progress ? '&hellip; ' + upload.progress + '%' : '&hellip;' }}
    </span>
  </div>

  <mat-form-field appearance="outline" class="mat-md full-height-textarea">
    <mat-label>Description</mat-label>
    <textarea appTrimInput formControlName="description" matInput rows="2"></textarea>
  </mat-form-field>
</div>
